<template>
  <div>
    <Breadcrumbs :title="'Home'"></Breadcrumbs>
    <ProjectOverview v-if="hasPermission('project.over_view')"></ProjectOverview>
    <TasksOverview v-if="hasPermission('task.over_view')"></TasksOverview>
    <StaticsChart v-if="hasPermission('project.over_view')"></StaticsChart>
    <ProjectRevenue v-if="hasPermission('project.revenue')"></ProjectRevenue>
    <RecentProject v-if="hasPermission('project.recent_projects')"></RecentProject>
    <RecentTask v-if="hasPermission('project.recent_tasks')"></RecentTask>
    <UserRecentTask v-if="hasPermission('task.user_recent_tasks')"></UserRecentTask>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import ProjectOverview from "@/components/dashboard/ProjectOverview.vue";
import TasksOverview from "@/components/dashboard/TasksOverview.vue";
import ProjectRevenue from "@/components/dashboard/ProjectRevenue.vue";
import RecentProject from "@/components/dashboard/RecentProject.vue";
import RecentTask from "@/components/dashboard/RecentTask.vue";
import UserRecentTask from "@/components/dashboard/UserRecentTasks.vue";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import StaticsChart from "@/components/dashboard/StaticsChart.vue";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Home",
  components: {
    ProjectOverview,
    TasksOverview,
    ProjectRevenue,
    RecentProject,
    RecentTask,
    Breadcrumbs,
    UserRecentTask,
    StaticsChart
},
  data: function () {
    return {
      statistics: [],
      count: 0,
      statsNotFound: require("@/assets/img/stats_empty.png"),
      role: localStorage.getItem('role') || null,
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile",
      hasPermission: "hasPermission",
    }),
    
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },

  watch: {

  },

  methods: {
    stringFormatting(str) {
      return str.replace(/_/g, " ")
    },
    memberCount(value) {
      this.count = value;
    }
  },

};
</script>